import React, { useEffect, useState, useRef } from "react";
import { Button, Card, Col, Form, Input, Row, Select, SelectProps } from "antd";
import { CloseOutlined, SaveOutlined, UserOutlined } from "@ant-design/icons";
import HTTPService from "../../../utils/makerequest";
import { Toast } from 'primereact/toast';
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { ICompanyData } from "../../../interfaces/ICompanyData";
import { useTranslation } from 'react-i18next';
import { IInventoryStatusData } from "../../../interfaces/IInventoryStatusData";

const AddInventoryStatus: React.FC<IInventoryStatusData> = ({ savedObj, companyId, inventoryStatusName, cancelModal }) => {
  const { t } = useTranslation();
  const toast = useRef<any>(null);
  const [companyData, setCompanyData] = useState<ICompanyData[]>();
  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();
  const isCompanyIdAvailable = !!companyId;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await HTTPService.GETCompanyNames();
    setCompanyData(result);
  };

  const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
    return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
  };

  const InventoryStatusRegister = (values) => {
    let companyIdToUse;
    if (userInfo?.role === UserRole.AltisAdmin) {
      companyIdToUse = values.selectedCompany;
    } else {
      companyIdToUse = userInfo?.companyId;
    }
    const newGroup = {
      inventoryStatusName: values.inventoryStatusName || inventoryStatusName,
      companyId: companyIdToUse || companyId,
    };

    HTTPService.POST(`/InventoryStatus/registerInventoryStatus`, newGroup)
      .then((response) => {
        if (response.status === 200) {
          const currentUrl = window.location.href;
          const redirectUrl = 'admin/add-inventory-status';
          if (currentUrl.includes(redirectUrl)) {
            toast.current?.show({
              severity: 'success',
              summary: t('successful'),
              detail:  t('successful'),
              life: 3000
            });
            window.location.replace('admin/inventory-status-management');
          }
          else if (response.status === 450) {
            toast.current?.show({
              severity: 'error',
              summary: t('mistake'),
              detail: t('mistake'),
              life: 3000
            });
          }
          else {
            savedObj(response.data)
            cancelModal();
          }
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((error) => {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t("Kategori kaydı başarısız: ") + error.message,
          life: 3000
        });
      });
  };



  const handleCancel = () => {
    const currentUrl = window.location.href;
    const addInventoryUrl = 'admin/add-inventory';
    const updateInventoryUrl = 'admin/update-inventory';
    const inventoryManage = 'admin/inventory-management';
    if (currentUrl.startsWith(addInventoryUrl)) {
      cancelModal();
    } else if (currentUrl.startsWith(updateInventoryUrl)) {
      cancelModal();
    } else if (currentUrl.includes(inventoryManage)) {
      cancelModal();
    } else {
      window.location.replace("/admin/inventory-status-management/");
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <Card style={{ padding: "50px" }}>
        <h3>{t('register_inventory_status')}</h3>
        <Form onFinish={InventoryStatusRegister} layout="vertical"
          fields={[
            { name: ["selectedCompany"], value: companyId },
          ]}
        >
          {!isCompanyIdAvailable && userInfo?.role === UserRole.AltisAdmin ? (
            <Form.Item
              name='selectedCompany'
              label={t('Select company')}
              rules={[
                {
                  required: true,
                  message: t('please_select_a_company'),
                },
              ]}
            >
              <Select showSearch placeholder={t('company_name')} style={{ marginBottom: '6px' }} filterOption={filterOption}>
                {companyData?.map((company) => (
                  <Select.Option key={company.companyId} value={company.companyId}>
                    {company.companyName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          ) : null}
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                name="inventoryStatusName"
                label={t('inventory_status_name')}
                rules={[
                  {
                    required: true,
                    message: t('please_input_your_inventory_status_name'),
                    whitespace: true,
                  }
                ]}
              >
                <Input
                  prefix={<UserOutlined />}
                  className="input-custom"
                  placeholder={t('inventory_status_name')}
                  style={{ borderRadius: 0 }}
                  maxLength={50}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Row gutter={[4, 4]} justify="end" align="middle">
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Button
                  block
                  onClick={handleCancel}
                  type="primary"
                  style={{
                    height: 64,
                    backgroundColor: 'transparent',
                    color: '#1890ff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 10px',
                    border: 'none',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                    e.currentTarget.style.color = '#40a9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.color = '#1890ff';
                  }}
                >
                  <CloseOutlined style={{ fontSize: 20 }} />
                  <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                    {t('cancel')}
                  </span>
                </Button>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Button
                  block
                  htmlType="submit"
                  type="primary"
                  style={{
                    height: 64,
                    backgroundColor: 'transparent',
                    color: '#1890ff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 10px',
                    border: 'none',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                    e.currentTarget.style.color = '#40a9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.color = '#1890ff';
                  }}
                >
                  <SaveOutlined style={{ fontSize: 20 }} />
                  <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                    {t('save')}
                  </span>
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
};

export default AddInventoryStatus;
